import http from "../http-common";

/**
 * Report a course has been activly viewed by a user
 *
 * @param courseId string
 * @return void
 */
export function reportCourseView(courseId: string): void {
  console.log(`/reporting/course-view/${courseId}`);
  http
    .post("/reporting/course-view", {
      courseId: courseId,
    })
    .catch((e) => {
      console.error(e);
    });
}

/**
 * Report the progress of a course by a user.
 *
 * @param courseId string
 * @param completedActivities number
 * @param totalActivities number
 */
export function reportCourseProgress(
  courseId: string,
  completedActivities: number,
  totalActivities: number
): void {
  http
    .post("/reporting/course-progress", {
      courseId: courseId,
      completedActivities: completedActivities,
      totalActivities: totalActivities
    })
    .catch((e) => {
      console.error(e);
    });
}

/**
 * Report a course has been activly viewed by a user
 *
 * @param courseId string
 * @return void
 */
export function reportResourceView(resourceId: string): void {
  console.log(`/reporting/resource-view/${resourceId}`);
  http
    .post("/reporting/resource-view", {
      resourceId: resourceId,
    })
    .catch((e) => {
      console.error(e);
    });
}

/**
 * Report the user has downloaded their resume
 *
 * @param resumeId string
 * @return void
 */
export function reportResumeDownloaded(resumeId: string): void {
  console.log(`/reporting/resume-downloaded/${resumeId}`);
  http
    .post("/reporting/resume-downloaded", {
      resumeId: resumeId,
    })
    .catch((e) => {
      console.error(e);
    });
}
